import React, { useRef, useEffect } from 'react';
import {default as formKitAutoAnimate, getTransitionSizes} from './index';

/**
 * Absolute coordinate positions adjusted for scroll.
 */
interface Coordinates {
    top: number;
    left: number;
    width: number;
    height: number;
}
export interface AutoAnimateOptions {
    /**
     * The time it takes to run a single sequence of animations in milliseconds.
     */
    duration: number;
    /**
     * The type of easing to use.
     * Default: ease-in-out
     */
    easing: "linear" | "ease-in" | "ease-out" | "ease-in-out" | string;
}
/**
 * A custom plugin that determines what the effects to run
 */
export interface AutoAnimationPlugin {
    <T extends "add" | "remove" | "remain">(el: Element, action: T, newCoordinates?: T extends "add" | "remain" | "remove" ? Coordinates : undefined, oldCoordinates?: T extends "remain" ? Coordinates : undefined): KeyframeEffect;
}

const AutoAnimate = ({children, options}: {children: any, options?: Partial<AutoAnimateOptions> | AutoAnimationPlugin}) => {
    const parent = useRef(null);

    useEffect(() => {
        parent.current && formKitAutoAnimate(parent.current, options)
    }, [parent])

    return <div ref={parent}>
        {children}
    </div>
}

export default AutoAnimate;

export const autoAnimate = (Component, options?: Partial<AutoAnimateOptions> | AutoAnimationPlugin) => React.forwardRef((props, ref) => {
    const parent = useRef(null);

    useEffect(() => {
        parent.current && formKitAutoAnimate(parent.current, options)
    }, [parent])

    return <Component ref={ref} {...props} animationRef={parent} />;
})

export {getTransitionSizes};